import APIUrl from "../../APIUrl";
import axios from "axios";
import { clearAuthentication } from "../../util/AuthUtil";

export const GET_NOTIFS = "GET_NOTIFS";
export const GET_UNREAD_COUNT = "GET_UNREAD_COUNT";
export const MARK_NOTIF_AS_READ = "MARK_NOTIF_AS_READ";
export const MARK_ALL_AS_READ = "MARK_ALL_AS_READ";

function getNotifsAction(notifications) {
  return { type: GET_NOTIFS, notifications: notifications };
}

function getUnreadCountAction(count) {
  return { type: GET_UNREAD_COUNT, count: count };
}

export const getNotifs = function (successCallback) {
  return function (dispatch) {
    return axios
      .get(APIUrl.getNotifs)
      .then(function (response) {
        if (response) {
          dispatch(getNotifsAction(response.data));
          if (successCallback) successCallback(response.data);
        }
      })
      .catch(function (err) {
        // Handle JWT errors
        if (err.response && err.response.status === 403) {
          clearAuthentication();
        }
      });
  };
};

export const getUnreadCount = function () {
  return function (dispatch) {
    return axios
      .get(APIUrl.getUnreadNotifCount)
      .then(function (response) {
        if (response && response.data) {
          dispatch(getUnreadCountAction(response.data.count));
        }
      })
      .catch(function (err) {
        // Handle JWT errors
        if (err.response && err.response.status === 403) {
          clearAuthentication();
        }
      });
  };
};

export const deleteNotif = function (data, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.deleteNotif, data)
      .then(function () {
        dispatch(getNotifs());
        if (successCallback) successCallback();
      })
      .catch(function (err) {
        throw err;
      });
  };
};

export const markNotifAsRead = function (notifId, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.markNotifAsRead, { notifId: notifId })
      .then(function () {
        dispatch({ type: MARK_NOTIF_AS_READ, notifId: notifId });
        dispatch(getUnreadCount());
        if (successCallback) successCallback();
      })
      .catch(function (err) {
        // Handle JWT errors
        if (err.response && err.response.status === 403) {
          clearAuthentication();
        }
      });
  };
};

export const markAllAsRead = function (successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.markAllNotifsAsRead)
      .then(function () {
        dispatch({ type: MARK_ALL_AS_READ });
        dispatch(getUnreadCount());
        if (successCallback) successCallback();
      })
      .catch(function (err) {
        // Handle JWT errors
        if (err.response && err.response.status === 403) {
          clearAuthentication();
        }
      });
  };
};

export const deleteAllNotifs = function (successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.deleteAllNotifs)
      .then(function () {
        dispatch(getNotifs());
        if (successCallback) successCallback();
      })
      .catch(function (err) {
        // Handle JWT errors
        if (err.response && err.response.status === 403) {
          clearAuthentication();
        }
      });
  };
};
